import type { Ref } from "react"
import {
  createContext,
  useContext,
} from "react"

export interface FormContextValue {
  formRef: Ref<HTMLFormElement>;
  isValid: boolean;
  recheckValidity: () => void;
}

type ContextType = FormContextValue | null
export const FormContext = createContext<ContextType>(null)

export function useFormContext(): ContextType {
  return useContext(FormContext)
}
